var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var History_1 = require("../common/History");
var URLS_1 = require("../common/constants/URLS");
var DynamicHOC_1 = require("../common/new-components/DynamicHOC");
var Widget_1 = require("./components/Widget");
exports.PRODUCTS = [
    {
        widget: 'bike-qf',
        path: URLS_1.default.BIKE_LANDING,
        pathPattern: URLS_1.default.BIKE_LANDING,
    },
    {
        widget: 'car-new',
        path: URLS_1.default.CAR_LANDING,
        pathPattern: URLS_1.default.CAR_LANDING,
    },
    {
        widget: 'bike-rp',
        path: URLS_1.default.BIKE_RESULTS,
        pathPattern: URLS_1.default.BIKE_RESULTS + ':quoteId',
    },
    {
        widget: 'bike-pf',
        path: URLS_1.default.BIKE_PROPOSAL,
        pathPattern: URLS_1.default.BIKE_PROPOSAL + ':slug/:transactionId',
    },
    {
        widget: 'travel-st',
        path: URLS_1.default.TRAVEL_SINGLETRIP,
        pathPattern: URLS_1.default.TRAVEL_SINGLETRIP,
    },
    {
        widget: 'travel-mt',
        path: URLS_1.default.TRAVEL_MULTITRIP,
        pathPattern: URLS_1.default.TRAVEL_MULTITRIP,
    },
    {
        widget: 'health-im',
        path: URLS_1.default.HEALTH_INDEMNITY,
        pathPattern: URLS_1.default.HEALTH_INDEMNITY,
    },
    {
        widget: 'health-st',
        path: URLS_1.default.HEALTH_SUPERTOPUP,
        pathPattern: URLS_1.default.HEALTH_SUPERTOPUP,
    },
    {
        widget: 'life-qf',
        path: URLS_1.default.LIFE_LANDING,
        pathPattern: URLS_1.default.LIFE_LANDING,
    },
    {
        widget: 'life-rp',
        path: URLS_1.default.LIFE_RESULTS,
        pathPattern: URLS_1.default.LIFE_RESULTS + ':quoteId',
    },
    {
        widget: 'life-rp',
        path: URLS_1.default.LIFE_PLANQUOTE,
        pathPattern: URLS_1.default.LIFE_PLANQUOTE + ':planQuoteId',
    },
    {
        widget: 'life-pf',
        path: URLS_1.default.LIFE_PROPOSAL,
        pathPattern: URLS_1.default.LIFE_PROPOSAL + ':proposalId',
    },
    {
        widget: 'ulip-qf',
        path: URLS_1.default.ULIP_LANDING,
        pathPattern: URLS_1.default.ULIP_LANDING,
    },
    {
        widget: 'ulip-rp',
        path: URLS_1.default.ULIP_RESULTS,
        pathPattern: URLS_1.default.ULIP_RESULTS + ':quoteId',
    },
    {
        widget: 'commercial-car',
        path: URLS_1.default.TAXI_LANDING,
        pathPattern: URLS_1.default.TAXI_LANDING,
    },
];
var REDIRECTS = [
    {
        from: '/',
        to: URLS_1.default.CAR_LANDING,
    },
    {
        from: URLS_1.default.BIKE_RESULTS,
        to: URLS_1.default.BIKE_LANDING,
    },
    {
        from: URLS_1.default.BIKE_PROPOSAL,
        to: URLS_1.default.BIKE_LANDING,
    },
    {
        from: URLS_1.default.LIFE_RESULTS,
        to: URLS_1.default.LIFE_LANDING,
    },
    {
        from: URLS_1.default.LIFE_PROPOSAL,
        to: URLS_1.default.LIFE_LANDING,
    },
    {
        from: URLS_1.default.ULIP_RESULTS,
        to: URLS_1.default.ULIP_LANDING,
    },
];
var WidgetWrapper = function (props) { return React.createElement(Widget_1.default, __assign({ updateURL: true }, props)); };
function WidgetRouter(props) {
    props = __assign({ entryPath: '/', buttonText: 'View Quotes' }, props);
    var HOCs = exports.PRODUCTS.map(function (_a) {
        var widget = _a.widget, path = _a.path, pathPattern = _a.pathPattern;
        return DynamicHOC_1.DynamicHOC(path, __assign({}, props[widget]));
    });
    HOCs[10] = HOCs[9];
    return (React.createElement(react_router_1.Router, { history: History_1.default }, [
        React.createElement(react_router_1.Route, { key: "r", path: props.entryPath, component: WidgetWrapper },
            React.createElement(react_router_1.IndexRoute, { component: HOCs[0] }),
            HOCs.map(function (Comp, index) { return (React.createElement(react_router_1.Route, { key: index, component: Comp, path: exports.PRODUCTS[index].pathPattern })); })),
    ].concat(REDIRECTS.map(function (props, index) { return React.createElement(react_router_1.Redirect, __assign({ key: index }, props)); }))));
}
exports.default = WidgetRouter;
